var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.25H12.5C13.1875 16.25 13.75 15.6875 13.75 15V5C13.75 4.3125 13.1875 3.75 12.5 3.75H5C4.3125 3.75 3.75 4.3125 3.75 5V15C3.75 15.6875 4.3125 16.25 5 16.25ZM5 26.25H12.5C13.1875 26.25 13.75 25.6875 13.75 25V20C13.75 19.3125 13.1875 18.75 12.5 18.75H5C4.3125 18.75 3.75 19.3125 3.75 20V25C3.75 25.6875 4.3125 26.25 5 26.25ZM17.5 26.25H25C25.6875 26.25 26.25 25.6875 26.25 25V15C26.25 14.3125 25.6875 13.75 25 13.75H17.5C16.8125 13.75 16.25 14.3125 16.25 15V25C16.25 25.6875 16.8125 26.25 17.5 26.25ZM16.25 5V10C16.25 10.6875 16.8125 11.25 17.5 11.25H25C25.6875 11.25 26.25 10.6875 26.25 10V5C26.25 4.3125 25.6875 3.75 25 3.75H17.5C16.8125 3.75 16.25 4.3125 16.25 5Z",
    fill: "#40BA21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconActive);
export default __webpack_public_path__ + "static/media/menu_icon_active.002bf522ef5d4a0ba986f65054402223.svg";
export { ForwardRef as ReactComponent };